import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useMemo, useState } from 'react';
import { Button, Center, VStack } from '@chakra-ui/react';
import { generateSequenceName, useT } from '@progress-fe/core';
import { v4 as uuidv4 } from 'uuid';
import { Dialog } from '../../base';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
import { JsFieldInspector } from '../../jsFormBase';
import { CatalystItem, CatalystReformingDetails } from './components';
/**
 * Component renders "/schemas/jsf-catalysts-list-reforming" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TCatalystsReformingListFormData.
 */
const CatalystsListReformingJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { t } = useT();
    const [selectedCatalyst, setSelectedCatalyst] = useState(null);
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: props.formData?.fieldConfig || null,
        values: props.formData?.fieldValues || null,
        watchPropsChanges: true,
        onChange: props.onChange
    });
    const isEmpty = !fieldValues?.length;
    const allNames = useMemo(() => {
        return fieldValues?.map((item) => item.name) ?? [];
    }, [fieldValues]);
    const handleAddCatalyst = () => {
        if (!fieldValues) {
            return;
        }
        const newCatalystValue = fieldConfig?.catalystConfig.groups.reduce((acc, curGroup) => {
            acc[curGroup.id] = curGroup.fields.reduce((fieldsAcc, curField) => {
                fieldsAcc[curField.id] = '';
                return fieldsAcc;
            }, {});
            return acc;
        }, {}) ?? {};
        const newCatalyst = {
            id: uuidv4(),
            name: generateSequenceName(allNames, 'Cat '),
            value: newCatalystValue
        };
        const newValues = [...fieldValues, newCatalyst];
        onChangeFieldValues(newValues);
    };
    const handleSelectCatalyst = (catalyst) => {
        setSelectedCatalyst(catalyst);
    };
    const handleDeleteCatalyst = (catalyst) => {
        const newValues = fieldValues?.filter((item) => item.id !== catalyst.id) ?? [];
        onChangeFieldValues(newValues);
    };
    const handleUpdateCatalyst = (newCatalyst) => {
        const newValues = fieldValues?.map((item) => (item.id === newCatalyst.id ? newCatalyst : item)) ?? [];
        setSelectedCatalyst(newCatalyst);
        onChangeFieldValues(newValues);
    };
    return (_jsxs(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: [_jsxs(VStack, { "data-testid": "CatalystsListReformingJsField-test", "data-name": props.name, gap: "8px", w: "100%", pb: "2px", children: [isEmpty && (_jsx(Center, { w: "100%", h: "64px", border: "1px solid", borderColor: "border", borderRadius: "4px", children: t('jsfields.CatalystsListReforming.noItems') })), !isEmpty && (_jsx(VStack, { gap: "4px", w: "100%", children: fieldValues.map((item) => (_jsx(CatalystItem, { catalyst: item, isReadonly: !!props.schema.readOnly, onSelect: () => handleSelectCatalyst(item), onDelete: () => handleDeleteCatalyst(item) }, item.id))) })), !props.schema.readOnly && (_jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleAddCatalyst, children: t('actions.add') }))] }), selectedCatalyst && fieldConfig && (_jsx(Dialog, { title: t('jsfields.CatalystsListReforming.catalystDetails'), onClose: () => setSelectedCatalyst(null), children: _jsx(CatalystReformingDetails, { catalyst: selectedCatalyst, config: fieldConfig.catalystConfig, onChange: handleUpdateCatalyst }) }))] }));
};
export const CatalystsListReformingJsField = memo(CatalystsListReformingJsFieldFC);
//# sourceMappingURL=CatalystsListReformingJsField.js.map